import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PAComponiFatturaComponent } from './pa-componi-fattura';


// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.pa-componi-fattura', {
            url: '/pa-componi-fattura',
            params: {
                xmlpath: '',
                requestNotaCredito : false
            },
            ncyBreadcrumb: {
                label: 'Componi Fattura',
                parent: 'home.fatturazione-pa'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi fattura e genera XML'
            },
            'views': {
                'homeContent': {
                    template: '<pa-componi-fattura flex="100"></pa-componi-fattura>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PAComponiFatturaModule: string = ng
    .module('pa-componi-fattura', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('paComponiFattura', PAComponiFatturaComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-componi-fattura/pa-componi-fattura.module.ts